// extracted by mini-css-extract-plugin
export default {"navLinks":"LandingNavContent-module__navLinks__U_8Lu","onboardBtn":"LandingNavContent-module__onboardBtn__jX4Y4"};